if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (window.BRRechargeOneTimeGuard) window.BRRechargeOneTimeGuard();
        const formData = new FormData(this.form);
        if (window.BRRechargeOneTimeGuard) window.BRRechargeOneTimeGuard(formData);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                    // Ensure cart drawer opens after modal closes
                    const drawer = document.querySelector('cart-drawer');
                    if (drawer && typeof drawer.open === 'function') {
                      drawer.open();
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
              // Ensure cart drawer opens after successful add
              const drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function') {
                drawer.open();
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


// BR temporary Recharge one-time guard - 2026-06-22
(function () {
  if (window.__brRechargeOneTimeGuard) return;
  window.__brRechargeOneTimeGuard = true;

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    return '$' + amount.toFixed(2);
  }

  function selectedVariantForForm(form) {
    if (!form) return null;
    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput && idInput.value;
    var productInfo = form.closest('product-info') || document;
    var variantsScript = productInfo.querySelector('variant-selects script[type="application/json"]');
    if (!variantId || !variantsScript) return null;

    try {
      var variants = JSON.parse(variantsScript.textContent || '[]');
      return variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      }) || null;
    } catch (error) {
      return null;
    }
  }

  function restoreVisibleOneTimePrices(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('product-form form').forEach(function (form) {
      var variant = selectedVariantForForm(form);
      var priceWrap = form.querySelector('.custom-price-middle-cart');
      if (!variant || !priceWrap) return;

      var price = formatMoney(variant.price);
      var compareAt = Number(variant.compare_at_price || 0);
      var hasCompareAt = compareAt > Number(variant.price || 0);

      priceWrap.querySelectorAll('.price-item--sale.price-item--last').forEach(function (node) {
        node.textContent = price;
      });

      priceWrap.querySelectorAll('.price__regular .price-item--regular').forEach(function (node) {
        node.textContent = price;
      });

      priceWrap.querySelectorAll('.price__sale s.price-item--regular').forEach(function (node) {
        node.textContent = hasCompareAt ? formatMoney(compareAt) : price;
      });
    });
  }

  function disableSellingPlanControls(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('[name="selling_plan"]').forEach(function (input) {
      input.value = '';
      input.disabled = true;
    });

    scope.querySelectorAll('[name^="selling_plan_"]').forEach(function (input) {
      input.disabled = true;
      input.checked = input.value === 'onetime';
    });

    scope.querySelectorAll('.rc-option__subsave input[type="radio"]').forEach(function (input) {
      input.checked = false;
    });

    scope.querySelectorAll('.rc-option__onetime input[type="radio"]').forEach(function (input) {
      input.checked = true;
    });

    restoreVisibleOneTimePrices(scope);
  }

  window.BRRechargeOneTimeGuard = function (formData) {
    disableSellingPlanControls(document);

    if (formData && typeof formData.delete === 'function') {
      formData.delete('selling_plan');
      Array.from(formData.keys()).forEach(function (key) {
        if (key.indexOf('selling_plan_') === 0) {
          formData.delete(key);
        }
      });
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    disableSellingPlanControls(document);

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        disableSellingPlanControls(document);
      });
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('product-info, .rc-container-wrapper, .rc_container_wrapper')) {
      window.setTimeout(function () { disableSellingPlanControls(document); }, 0);
    }
  }, true);

  document.addEventListener('submit', function () {
    disableSellingPlanControls(document);
  }, true);
})();

